import { Box } from "@mui/material";
import React, { Dispatch, FC, JSX, SetStateAction } from "react";
import TableController from "./TableController";
import { AiFillLinkedin } from "react-icons/ai";
import MainTable from "./MainTable";
import AddIcon from "@mui/icons-material/Add";
import {
  ActionButtonTypes,
  KATableActionBttnsTypes,
  KATableHeaderTypes,
} from "./SweetTable.interface";
import { ITableInstance } from "ka-table";
type MainTableContainerProps = {
  tableTitle?: string;
  setSearchText?: Dispatch<SetStateAction<string>>;
  tableColumns: Array<KATableHeaderTypes>;
  tableData: Array<any>;
  searchText?: string;
  rowKeyField?: string;
  cellActionBtns?: Array<KATableActionBttnsTypes>;
  actionBtns?: Array<ActionButtonTypes>;
  downLoadPDF?: boolean;
  downloadEXCEL?: boolean;
  pdfAction?: any;
  excelAction?: any;
  table: ITableInstance;
  filterApplicable?: boolean;
  pageIndex?: number;
  APILoading?: boolean;
  pageSize?: number;
  searchAction?: (params: any) => void;
  isSSR?: boolean;
  pageCount?: number;
  actionBtnsReq?: boolean;
  customeComponent?: any;
  orientaion?: "landscape" | "portrait";
  ExcelDownloadFromServer?: any;
  rowColors?: Array<{ index: number; color: string }>;
  searchTitle?: string;
  isPaging?: boolean;
  searchDropdownLabel?: any;
  searchDropdownKey?: any;
  searchDropdownList?: any[];
  FormHandler?: any;
  setSearchKeyVal?: any;
  isTypeSearch?: boolean;
  CustomePageSizes?: number[];
  isPageSizeGiven?: boolean;
  searchClearAction?: any;
  filtersAllow?: boolean;
  ColumnSettings?: boolean;
  isRightClickable?:any;
};
const MainTableContainer: FC<MainTableContainerProps> = ({
  tableTitle,
  searchText,
  setSearchText,
  actionBtns,
  tableData,
  tableColumns,
  cellActionBtns,
  downLoadPDF = false,
  downloadEXCEL = false,
  pdfAction,
  excelAction,
  table,
  pageIndex,
  APILoading,
  filterApplicable,
  pageSize,
  searchAction,
  isSSR,
  pageCount,
  actionBtnsReq,
  customeComponent,
  orientaion,
  ExcelDownloadFromServer,
  rowColors,
  searchTitle,
  isPaging,
  FormHandler,
  searchDropdownKey,
  rowKeyField,
  searchDropdownLabel,
  searchDropdownList,
  setSearchKeyVal,
  isTypeSearch,
  CustomePageSizes,
  isPageSizeGiven,
  searchClearAction,
  filtersAllow = true,
  ColumnSettings = false,
  isRightClickable
}): JSX.Element => {
  return (
    <Box>
      <TableController
        tableTitle={tableTitle}
        searchText={searchText}
        setSearchText={setSearchText}
        actionBtns={actionBtns}
        downLoadPDF={downLoadPDF}
        downloadEXCEL={downloadEXCEL}
        pdfAction={pdfAction}
        tableColumns={tableColumns}
        tableData={tableData}
        excelAction={excelAction}
        isSSR={isSSR}
        searchAction={searchAction}
        actionBtnsReq={actionBtnsReq}
        orientaion={orientaion}
        ExcelDownloadFromServer={ExcelDownloadFromServer}
        searchTitle={searchTitle}
        FormHandler={FormHandler}
        searchDropdownKey={searchDropdownKey}
        searchDropdownLabel={searchDropdownLabel}
        searchDropdownList={searchDropdownList}
        setSearchKeyVal={setSearchKeyVal}
        isTypeSearch={isTypeSearch}
        searchClearAction={searchClearAction}
        filtersAllow={filtersAllow}
        ColumnSettings={ColumnSettings}
      />
      <MainTable
        tableColumns={tableColumns}
        tableData={tableData}
        searchText={searchText}
        cellActionBtns={cellActionBtns}
        table={table}
        tableTitle={tableTitle}
        pageIndex={pageIndex}
        APILoading={APILoading}
        pageSize={pageSize}
        isSSR={isSSR}
        pageCount={pageCount}
        customeComponent={customeComponent}
        rowColors={rowColors}
        searchTitle={searchTitle}
        isPaging={isPaging}
        CustomePageSizes={CustomePageSizes}
        isPageSizeGiven={isPageSizeGiven}
        filtersAllow={filtersAllow}
        ColumnSettings={ColumnSettings}
      />
    </Box>
  );
};

export default MainTableContainer;
